import { GraphQLClient } from "graphql-request";
import * as proposals from "../generated/proposals.sdk";
import { lazyInit } from "./utils";
export const getProposalsGraphqlClient = lazyInit(async () => new GraphQLClient(window.__ENV_CONFIG.apiUrls.proposals));
export const getProposalsSdk = lazyInit(() => getProposalsGraphqlClient().then(proposals.getSdk));
//# sourceMappingURL=proposals.js.map